export const srSpeak = (
  text: string,
  priority: React.AriaAttributes['aria-live'] = 'polite',
): void => {
  const el = document.createElement('div') as HTMLDivElement;
  const id = `speak-${new Date().getTime()}`;
  el.setAttribute('id', id);
  el.setAttribute('aria-live', priority);
  el.classList.add('sr-only');
  document.body.appendChild(el);

  window.setTimeout(() => {
    el.innerHTML = text;
  }, 100);

  window.setTimeout(() => {
    document.body.removeChild(el);
  }, 1000);
};
